// node_modules/srraf/dist/srraf.es.js
var n;
var e;
var i;
var o;
var t;
var r;
var f;
var d;
var p;
var u = [];
function w(n2, a) {
  return e = window.pageXOffset, o = window.pageYOffset, r = window.innerHeight, d = window.innerWidth, void 0 === i && (i = e), void 0 === t && (t = o), void 0 === p && (p = d), void 0 === f && (f = r), (a || o !== t || e !== i || r !== f || d !== p) && (!function(n3) {
    for (var w2 = 0; w2 < u.length; w2++) u[w2]({ x: e, y: o, px: i, py: t, vh: r, pvh: f, vw: d, pvw: p }, n3);
  }(n2), i = e, t = o, f = r, p = d), requestAnimationFrame(w);
}
function srraf_es_default(e2) {
  return u.indexOf(e2) < 0 && u.push(e2), n = n || w(performance.now()), { update: function() {
    return w(performance.now(), true), this;
  }, destroy: function() {
    u.splice(u.indexOf(e2), 1);
  } };
}

// src/scripts/fluco-lib/media-queries.js
function getMediaQuery(querySize, sectionElement) {
  const value = getComputedStyle(sectionElement).getPropertyValue(
    `--fluco-js-${querySize}`
  );
  if (!value) {
    console.warn("Invalid querySize passed to getMediaQuery");
    return false;
  }
  return value;
}
function checkMediaQuery(querySize, sectionElement) {
  const mediaQuery = getMediaQuery(querySize, sectionElement);
  return window.matchMedia(mediaQuery).matches;
}

// src/scripts/fluco-lib/media-aspect-ratios.js
function getMediaAspectRatio(isMobile, mediaElement) {
  let activeAspectRatioTarget = "--aspect-ratio";
  if (isMobile) {
    activeAspectRatioTarget = `${activeAspectRatioTarget}-mobile`;
  }
  const computedStyles = getComputedStyle(mediaElement);
  const activeAspectRatioString = computedStyles.getPropertyValue(
    activeAspectRatioTarget
  );
  const activeAspectRatio = parseFloat(activeAspectRatioString);
  if (!activeAspectRatio) {
    console.warn(
      "Invalid mobile state or element passed to getMediaAspectRatio"
    );
    return null;
  }
  return activeAspectRatio;
}

// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  SWIPER_JS_LOADED: "fluco_section:swiper_js_loaded",
  LOOPING_SWIPER_INITIALIZED: "fluco_section:looping_swiper_initialized",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed",
  SHOP_THE_LOOK_HOTSPOT_CLICKED: "fluco_section:shop_the_look_hotspot_clicked"
};
var events_default = EVENTS;

// src/scripts/sections/shoppable-feed-1.js
var { LOOPING_SWIPER_INITIALIZED } = events_default;
var ShoppableFeed1 = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      section: ".fluco-section",
      videoSwiperContainer: "[js-looping-swiper]",
      originalSlide: ".swiper-slide[js-original-slide]",
      activeSlide: ".swiper-slide-active",
      slideMediaContent: "[js-slide-media-content]",
      slideProductCardContent: "[js-slide-product-card-content]",
      slideImage: ".fluco-looping-swiper-slide__image"
    };
    this.attrs = {
      inactiveSlideHeight: "data-inactive-slide-height"
    };
    this.styleProperties = {
      inactiveSlideHeightPxValue: "--inactive-slide-height-px-value",
      activeSlideHeightPxValue: "--active-slide-height-px-value",
      activeMediaHeightPxValue: "--active-media-height-px-value",
      inactiveMediaHeightPxValue: "--inactive-media-height-px-value",
      sectionHeightPxValue: "--section-height-px-value",
      productCardHeightPxValue: "--product-card-height-px-value"
    };
  }
  connectedCallback() {
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.section = this.closest(this.selectors.section);
    this.videoSwiperContainer = this.querySelector(
      this.selectors.videoSwiperContainer
    );
    this.originalSlideSet = this.querySelectorAll(this.selectors.originalSlide);
    this.section.addEventListener(
      LOOPING_SWIPER_INITIALIZED,
      () => {
        this.setSlideMediaHeight();
        this.setSlideProductCardHeight();
      },
      this.eventOptions
    );
    this.widthWatcher = srraf_es_default(({ vw, pvw }) => {
      if (vw === pvw) return;
      setTimeout(() => {
        this.setSlideMediaHeight();
        this.setSlideProductCardHeight();
      }, 100);
    });
  }
  setSlideMediaHeight() {
    const activeSlide = this.querySelector(this.selectors.activeSlide);
    if (!activeSlide) return;
    const isMobile = checkMediaQuery("mobile", this);
    const activeSlideMedia = activeSlide.querySelector(
      this.selectors.slideMediaContent
    );
    const activeAspectRatio = getMediaAspectRatio(isMobile, activeSlideMedia);
    const activeWidth = activeSlideMedia.getBoundingClientRect().width;
    if (activeWidth === 0) return;
    const activeMediaHeight = Math.round(activeWidth / activeAspectRatio);
    const inactiveModifier = parseFloat(
      this.videoSwiperContainer.getAttribute(this.attrs.inactiveSlideHeight) / 100
    );
    const inactiveMediaHeight = activeMediaHeight * inactiveModifier;
    this.videoSwiperContainer.style.setProperty(
      this.styleProperties.activeMediaHeightPxValue,
      `${activeMediaHeight}px`
    );
    this.videoSwiperContainer.style.setProperty(
      this.styleProperties.inactiveMediaHeightPxValue,
      `${inactiveMediaHeight}px`
    );
  }
  setSlideProductCardHeight() {
    let maxProductCardHeight = 0;
    this.originalSlideSet.forEach((slide) => {
      const productCard = slide.querySelector(
        this.selectors.slideProductCardContent
      );
      if (productCard.clientHeight > maxProductCardHeight) {
        maxProductCardHeight = productCard.clientHeight;
      }
    });
    this.videoSwiperContainer.style.setProperty(
      this.styleProperties.productCardHeightPxValue,
      `${maxProductCardHeight}px`
    );
  }
  disconnectedCallback() {
    this.eventController.abort();
    this.swiperInstance?.destroy();
    this.widthWatcher?.destroy();
  }
};
if (!customElements.get("fluco-local-v1-shoppable-feed-1")) {
  customElements.define("fluco-local-v1-shoppable-feed-1", ShoppableFeed1);
}
